import type { RouteRecordRaw } from 'vue-router';

// Only the index; deeper /clusters paths are legacy's. LEGACY_NESTED_ONLY_PATHS
// stops routes/legacy.ts emitting a competing record for this exact path.
const clusterRoutes: RouteRecordRaw[] = [
  {
    path: '/clusters',
    name: 'clusters-list',
    component: () => import('@/domains/clusters/views/ClustersListView.vue'),
    meta: { renderer: 'native', perms: ['cluster@view'] },
  },
];

// Canvas chrome: the wizard owns its own left rail (STEP1…4).
clusterRoutes.push({
  path: '/add-cluster',
  name: 'clusters-add',
  component: () => import('@/domains/clusters/views/AddClusterView.vue'),
  meta: { renderer: 'native', layout: 'canvas', perms: ['cluster@create'] },
});

export default clusterRoutes;
